import { baseTheme } from '@src/theme';
import { Carousel } from 'antd';
import { styled } from 'styled-components';

export const StyledCarousel = styled(Carousel)`
    .slick-dots {
        li {
            width: 10px;
            height: 10px;

            button {
                border-radius: 50%;
                width: 100%;
                height: 100%;
                background: ${(props) =>
                    props.theme?.colors?.secondary?.main?.text ||
                    baseTheme.colors.secondary.main.text};
                opacity: 0.4;
            }

            &.slick-active {
                width: 10px;
                height: 10px;
                button {
                    background: ${(props) =>
                        props.theme?.colors?.primary?.main?.filled ||
                        baseTheme.colors.primary.main.filled};
                    opacity: 1;
                }
                &::after {
                    display: none;
                }
            }
        }
    }

    .slick-arrow {
        color: ${(props) =>
            props.theme?.colors?.secondary?.light?.contentBg ||
            baseTheme.colors.secondary.light.contentBg};
        background-color: ${(props) =>
            props.theme?.colors?.secondary?.main?.surfaceBg ||
            baseTheme.colors.secondary.main.surfaceBg};

        &:hover,
        &:focus {
            color: ${(props) =>
                props.theme?.colors?.secondary?.light?.contentBg ||
                baseTheme.colors.secondary.light.contentBg};
            background-color: ${(props) =>
                props.theme?.colors?.secondary?.dark?.surfaceBg ||
                baseTheme.colors.secondary.dark.surfaceBg};
        }
    }
`;
